import {
  Box,
  Button,
  Card,
  FormHelperText,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material';
import { IOrderSeedingCreate } from '../../../../@types/order';
import Iconify from 'components/iconify/Iconify';
import Scrollbar from 'components/scrollbar/Scrollbar';
import { useEffect, useState } from 'react';
import { createOrder } from 'redux/slices/order-seeding';
import { checkMe } from 'redux/slices/user';
import AppWidget from 'sections/@dashboard/app/app-widget';
import { useRouter } from 'next/router';

export interface IOrderMultiple {
  data: { [x: string]: any } | null;
  onClose: () => void;
}

export interface IItemOrder {
  uid: string;
  isSuccess: boolean;
  message: string;
  isProcess?: boolean;
}

async function waitTime(second = 1) {
  return new Promise((resolve) => {
    setTimeout(resolve, second * 1000);
  });
}

export default function OrderMultiple({ data, onClose }: IOrderMultiple) {
  const router = useRouter();
  const [percent, setPercent] = useState<number>(0);
  const [uids, setUids] = useState<string[]>([]);
  const [success, setSuccess] = useState<IItemOrder[]>([]);
  const [faild, setFaild] = useState<IItemOrder[]>([]);
  const [process, setProcess] = useState<IItemOrder | null>(null);

  useEffect(() => {
    const uids = data?.uid?.split('\n').filter((uid: string) => uid.trim() !== '') ?? [];
    setUids(uids);
  }, [data?.uid]);

  useEffect(() => {
    const numTotal = uids.length;
    const numSuccess = success.length;
    const numFaild = faild.length;
    setPercent(((numSuccess + numFaild) / numTotal) * 100);
  }, [uids, success, faild]);

  useEffect(() => {
    const orderMultiples = async () => {
      //đặt đơn hàng
      for (let uid of uids) {
        setProcess({ uid: uid, isProcess: true, isSuccess: false, message: 'Processing...' });
        const [_, error] = await createOrder({ ...data, uid: uid } as IOrderSeedingCreate);
        if (error) {
          setFaild((prevFaild) => [
            ...prevFaild,
            { uid: uid, isSuccess: !!error, message: error ? error.errors[0].message : '' },
          ]);
        } else {
          setSuccess((prevSuccess) => [
            ...prevSuccess,
            {
              uid: uid,
              isSuccess: !error,
              message: _?.code ?? '',
            },
          ]);
        }
        setProcess(null);
        await waitTime();
      }
      checkMe();
    };
    orderMultiples();
  }, [uids]);

  return (
    <>
      <Card sx={{ width: '100%' }}>
        <Stack>
          <AppWidget
            title="Tiến trình đang chạy. Vui lòng không tắt cho đến khi hoàn tất"
            total={uids.length}
            success={success.length}
            faild={faild.length}
            icon="solar:user-rounded-bold"
            chart={{
              series: percent,
            }}
          />
          <Stack>
            <Scrollbar
              sx={{
                maxHeight: 300,
                height: 1,
                '& .simplebar-content': {
                  height: 1,
                  display: 'flex',
                  flexDirection: 'column',
                },
              }}
            >
              <List>
                {process && (
                  <ItemOrder
                    isProcess={process.isProcess}
                    isSuccess={process.isSuccess}
                    uid={process.uid}
                    message={process.message}
                  />
                )}
                {faild.map((m, index) => (
                  <ItemOrder
                    key={index.toString()}
                    isSuccess={m.isSuccess}
                    uid={m.uid}
                    message={m.message}
                  />
                ))}
                {success.map((m, index) => (
                  <ItemOrder
                    key={index.toString()}
                    isSuccess={m.isSuccess}
                    uid={m.uid}
                    message={m.message}
                  />
                ))}
              </List>
            </Scrollbar>
          </Stack>
        </Stack>
      </Card>
      <Stack sx={{ mt: 2 }} direction="row" spacing={2} justifyContent="center" alignItems="center">
        <Button
          startIcon={<Iconify icon="line-md:cancel" />}
          variant="outlined"
          color="error"
          onClick={() => router.reload()}
          disabled={success.length + faild.length >= uids.length}
        >
          Hủy tiến trình
        </Button>
        <Button
          disabled={success.length + faild.length < uids.length}
          startIcon={<Iconify icon="line-md:close" />}
          variant="outlined"
          color="primary"
          onClick={onClose}
        >
          Đóng
        </Button>
      </Stack>
    </>
  );
}

export function ItemOrder({ isSuccess, uid, message, isProcess }: IItemOrder) {
  return (
    <ListItem sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', py: 0 }}>
      <ListItemIcon>
        <IconButton color={isProcess ? 'primary' : isSuccess ? 'success' : 'error'}>
          <Iconify
            icon={
              isProcess
                ? 'eos-icons:bubble-loading'
                : isSuccess
                ? 'ep:success-filled'
                : 'material-symbols:error-rounded'
            }
          />
        </IconButton>
      </ListItemIcon>
      <ListItemText
        sx={{ p: 0, m: 0 }}
        primary={
          <Typography color="primary" variant="body2" noWrap>
            {uid}
          </Typography>
        }
        secondary={<FormHelperText error={!isSuccess}>{message}</FormHelperText>}
      ></ListItemText>
    </ListItem>
  );
}
